import { Fragment, ReactElement } from 'react';

import { usePopover } from './hooks';

import {
  PopoverContainer,
  KebabItemButton,
  KebabItemText,
  StyledPopover,
} from './Filters.components';
import { HeaderButton } from '../buttons';

export const NotificationMenu = (): ReactElement => {
  const { isOpen, id, anchorEl, toggle, close } = usePopover(
    'notification-popover',
  );

  return (
    <Fragment>
      <HeaderButton onClick={toggle}>
        <svg
          width="21"
          height="22"
          viewBox="0 0 21 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.966 20C9.14154 20.304 9.39402 20.5565 9.69804 20.732C10.0021 20.9075 10.3469 20.9999 10.698 20.9999C11.0491 20.9999 11.3939 20.9075 11.698 20.732C12.002 20.5565 12.2545 20.304 12.43 20M1.96 14.326C1.82936 14.4692 1.74315 14.6472 1.71186 14.8385C1.68056 15.0298 1.70552 15.226 1.78371 15.4034C1.86189 15.5807 1.98994 15.7316 2.15226 15.8375C2.31458 15.9434 2.50418 15.9999 2.698 16H18.698C18.8918 16.0001 19.0814 15.9438 19.2439 15.8381C19.4063 15.7324 19.5345 15.5817 19.6129 15.4045C19.6913 15.2273 19.7165 15.0311 19.6854 14.8398C19.6544 14.6485 19.5684 14.4703 19.438 14.327C18.108 12.956 16.698 11.499 16.698 7C16.698 5.4087 16.0659 3.88258 14.9406 2.75736C13.8154 1.63214 12.2893 1 10.698 1C9.1067 1 7.58058 1.63214 6.45536 2.75736C5.33014 3.88258 4.698 5.4087 4.698 7C4.698 11.499 3.287 12.956 1.96 14.326Z"
            stroke="#EDEEF7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </HeaderButton>

      <StyledPopover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{ zIndex: 10 }}
        id={id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={close}
      >
        <PopoverContainer>
          {/* <KebabItemButton>
            <KebabItemText primary={'Logout'} />
          </KebabItemButton> */}
        </PopoverContainer>
      </StyledPopover>
    </Fragment>
  );
};
